import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as fromUser from '@app/core/user/store/reducers';
import { Product } from '@vestiaire/api-sdk-angular';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Subject } from 'rxjs';

export interface CarouselProductClick {
  product: Product;
  position: number;
}

@Component({
  selector: 'vc-carroussel-products',
  templateUrl: './carroussel-products.component.html',
  styleUrls: ['./carroussel-products.component.scss']
})
export class CarrousselProductsComponent {
  @Input() items: Product[];
  @Input() seoContext: string[] = [];

  @Output() carouselProductClick = new EventEmitter<CarouselProductClick>();

  carouselSubject = new Subject();

  likedItem: string[] = [];
  isMdUp = false;
  eventClick: Event;

  constructor(private store: Store<IAppState>) {
    this.store.pipe(select(fromUser.getLikedItems)).subscribe(
      productsLiked => productsLiked && (this.likedItem = productsLiked['products']),
      error => console.error(error)
    );
    this.store.select('device').subscribe(
      device => device && (this.isMdUp = device.isMdUp),
      error => console.error(error)
    );
  }

  scrollToNext(el: HTMLElement) {
    const left = el.scrollLeft + el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
  }

  scrollToPrev(el: HTMLElement) {
    const left = el.scrollLeft - el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
  }

  onProductClick(product: Product, position: number) {
    const event: CarouselProductClick = { product, position };
    this.carouselProductClick.emit(event);
  }
}
